module.exports = __webpack_public_path__ + "img/TumiLogo.1596ba5a.png";